module.exports = __webpack_public_path__ + "img/file_upload_white.852d87e5.svg";